import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { moduleApi } from "~/api";
import { ModulesLayout } from "~/features/module";
import { useBuildingContext } from "~/providers/building.provider";

export const Route = createFileRoute("/_authenticated/buildings_/$buildingId/settings/bms/modules")({
  loader: async ({ context: { queryClient }, params: { buildingId } }) => {
    await queryClient.ensureQueryData(moduleApi.queries.building(buildingId));
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { buildingId } = Route.useParams();
  const { data: modules } = useSuspenseQuery(moduleApi.queries.building(buildingId));
  const { boilerRooms, airHandlerUnits, gateways, floors, permissions } = useBuildingContext(Route.id);

  return (
    <ModulesLayout
      buildingId={buildingId}
      modules={modules}
      boilerRooms={boilerRooms}
      airHandlerUnits={airHandlerUnits}
      gateways={gateways}
      floors={floors}
      permissions={permissions}
    />
  );
}
